import React from 'react';
import ColorSwatch from 'components/colorSwatch/color-swatch';
import { getActiveIcon } from 'library/helpers';
import { durationString } from 'library/time';
import { THEME_NAMES } from 'selectors/tag.selectors';
import { ItemTags } from 'views/shared/ItemTags';
import { DocLink, DocPages } from 'components/Help';
import { Notifications } from 'views/shared/Notifications';
import { ActivityTemplates } from './Templates';
import { ActivityCompetencies } from './Competencies';
import ActivityFormInput from './input';

const config = {
  init: {
    color: '#000',
    active: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Type',
        dataIndex: 'activity_type__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => (`${record.activity_type.name} (${record.activity_type.code})`)
      },
      {
        title: 'Duration',
        dataIndex: 'duration',
        width: '120px',
        align: 'center',
        sorter: true,
        render: (text, record) => (durationString(record.duration))
      },
      {
        title: 'Colour',
        dataIndex: 'color',
        width: '110px',
        align: 'center',
        sorter: false,
        render: (text, record) => (<ColorSwatch value={record.color} />)
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '140px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [{
          text: 'Yes',
          value: true
        }, {
          text: 'No',
          value: false
        }],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the activity
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      },
      activity_type__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['activity_type__code'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.activities}>Activities</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select an Activity',
    title: 'Activity',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <ActivityFormInput
            {...props}
            title="Activity"
          />
        )
      },
      {
        key: 1,
        title: 'Templates',
        component: props => (
          <ActivityTemplates
            {...props}
          />
        )
      },
      {
        key: 2,
        title: 'Competencies',
        component: props => (
          <ActivityCompetencies
            {...props}
          />
        )
      },
      {
        key: 3,
        title: 'Tags',
        component: props => (
          <ItemTags
            {...props}
            themeName={THEME_NAMES.activity}
          />
        )
      },
      {
        key: 4,
        title: 'Default Notifications',
        component: props => (
          <Notifications
            {...props}
            themeName="activity"
          />
        )
      }
    ]
  }
};

export default config;
